import React from "react";
import { Navigate, useRoutes } from "react-router-dom";
import { LoginPage, RegisterPage } from "../Pages/auth";
import MainLayout from "../Layout";
import ApplicationStatus from "../Pages/ApplicationStatus";
import UpgradeMembership from "../Pages/app/Upgrade";
import PaymentReceived from "../Pages/PaymentReceived";
import UserForm from "../Pages/admin/UserForm";
import ApplicationCancelled from "../Pages/ApplicationCancelled";
import RenewRevive from "../Pages/admin/RenewRevive";
import ExistingMembershipForm from "../Components/ExistingMemberShipForm";
import SuccessPage from "../Components/ExistingMemberShipForm/SuccessPage";
import OfficeUpdateForm from "../Pages/office-update/OfficeUpdateForm";
import PaymentLinkExpired from "../Pages/PaymentLinkExpired";

export default function PublicRoutes() {
  return useRoutes([
    {
      path: "/login",
      element: <LoginPage />,
    },
    {
      path: "/register",
      element: <MainLayout />,
      children: [{ path: "user/:step/:user_id?", element: <RegisterPage /> }],
    },
    {
      path: "/application/:num/:user_id/:status",
      element: <ApplicationStatus />,
    },
    {
      path: "app",
      element: <MainLayout />,
      children: [
        { path: "upgrade/:step/:user_id?", element: <UpgradeMembership /> },
      ],
    },
    {
      path: "payment-received",
      element: <PaymentReceived />,
    },
    {
      path: "payment-expired",
      element: <PaymentLinkExpired />,
    },
    {
      path: "application-cancelled/:user_id?",
      element: <ApplicationCancelled />,
    },
    {
      path: "admin-update",
      element: <MainLayout />,
      children: [{ path: "user/:step/:user_id?", element: <UserForm /> }],
    },
    {
      path: "user/update-details/:user_id/:from?",
      element: <ExistingMembershipForm />,
    },
    {
      path: "user/update-details/:user_id/thanks/:recorded",
      element: <SuccessPage />,
    },
    {
      path: "renew-checkout-revive/:app_id",
      element: <RenewRevive />,
    },
    {
      path: "office-update",
      element: <MainLayout />,
      // In user_id receiving app_id
      children: [
        { path: "user/:step/:user_id?", element: <OfficeUpdateForm /> },
      ],
    },
    {
      path: "*",
      element: <Navigate to={"/login"} replace />,
    },
  ]);
}
